// /XXX: This is a first attempt to remove
// ' Warning: React does not recognize the `hasCreate` prop on a DOM element. If you i..'
// kind of warnings.
export function sanitizeButtonProps(props) {
  const { hasCreate, hasEdit, hasList, hasShow, ...res } = props;
  return res;
}
